<template>
  <v-row>
    <v-col cols="12" lg="7" xl="6" class="background-login d-none d-md-flex align-center justify-center"> </v-col>
    <v-col cols="12" lg="5" xl="6" class="d-flex align-center">
      <v-container>
        <div class="pa-7 pa-sm-12">
          <v-row class="justify-center">
            <v-col cols="12" lg="12" xl="6">
              <div style="text-align:center">
                <div style="max-height:100px !important" class="mt-6">
                  <img width="100" src="@/assets/images/logo-agrovision.svg" />
                </div>
                <h2 class="my-5">Login de Trabajador</h2>
              </div>
              <v-form ref="form" v-model="valid" lazy-validation action="/">
                <v-text-field
                  v-model="usuario"
                  :rules="usuarioRules"
                  label="Usuario"
                  class="mt-4"
                  required
                  outlined
                  prepend-inner-icon="fas fa-id-badge"
                >
                </v-text-field>
                <v-text-field
                  v-model="clave"
                  :rules="claveRules"
                  label="Contraseña"
                  required
                  outlined
                  :type="show1 ? 'text' : 'password'"
                  :append-icon="show1 ? 'fas fa-eye' : 'fas fa-eye-slash'"
                  @click:append="show1 = !show1"
                ></v-text-field>
                <v-select
                  :items="data"
                  v-model="empresa"
                  :rules="empresaRules"
                  label="Empresa"
                  outlined
                  required
                  prepend-inner-icon="fas fa-building"
                ></v-select>
                <v-btn :disabled="!valid" color="info" block class="mr-4" submit @click="submit">Iniciar Sesión</v-btn>
              </v-form>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-col>
  </v-row>
</template>

<script>
import LoginService from '../services/LoginService';
import Swal from 'sweetalert2';
export default {
  name: 'LoginJob',
  data: () => ({
    loginService: null,
    valid: true,
    clave: '',
    empresa: '',
    show1: false,
    usuario: '',
    claveRules: [(v) => !!v || 'Contraseña es requerida.'],
    usuarioRules: [(v) => !!v || 'Usuario es requerido.'],
    empresaRules: [(v) => !!v || 'Empresa es requerida'],
    checkbox: false,
    data: []
  }),
  methods: {
    upperCase() {
      this.usuario = this.usuario.toUpperCase();
    },
    async iniciaData() {
      const res = await this.loginService.get().execResource('empresas', {
        api_token: 'BBBBBBBBBBB*cXXVOkdQgiJBJBBCKF'
      });
      res.forEach((element) => {
        this.data.push({ text: element.razonsocial, value: element.idempresa });
      });
    },
    async submit() {
      this.$refs.form.validate();
      if (this.$refs.form.validate(true)) {
        const res = await this.loginService.post().execResource('loginJob', {
          usuario: this.usuario,
          clave: this.clave,
          idempresa: this.empresa
        });

        if (!res.status) {
          await Swal.fire({
            icon: 'error',
            title: res.message,
            confirmButtonText: `OK`
          });
          return;
        }

        await this.setLocal(res);
        this.$router.push({ path: '/eleccion' });
      }
    },
    async setLocal(res) {
      localStorage.setItem('tokenjob', res.data.token);
      localStorage.setItem('empjob', this.empresa);
      localStorage.setItem('userjob', this.usuario);
      localStorage.setItem('passwordjob', this.clave);
      localStorage.setItem('idtrabajador', res.data.trabajador.idtrabajador);
      localStorage.setItem('idcliente', res.data.trabajador.idcliente);
    }
  },
  created() {
    this.usuario = localStorage.getItem('userjob');
    this.clave = localStorage.getItem('passwordjob');
    this.empresa = localStorage.getItem('empjob');
  },
  async mounted() {
    if (localStorage.getItem('tokenjob') != undefined) {
      this.$router.push({ path: '/eleccion' });
    } else {
      this.loginService = this.$httpService(new LoginService(), this);
      await this.iniciaData();
    }
  }
};
</script>
<style lang="css">
.background-login {
  background: url('../../../assets/images/background/bg-login-empleado.jpg') no-repeat;
  background-size: cover;
  /*background: url('../../../assets/images/background/bg-login.jpg') no-repeat fixed center;*/
  /*background-size: contain;*/
  /* background-position: initial;*/
}
</style>
